import Immutable from 'seamless-immutable'
import * as types from './constants'

const initialState = Immutable({
  processesList: {
    count: 0,
    values: [],
  },
  auditList: {
    count: 0,
    values: [],
  },
})

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROCESSES_LIST_SUCCESS:
      return state.merge({
        processesList: {
          count: action.payload.data.count,
          values: action.payload.data.results,
        },
      })

    case types.FETCH_AUDIT_LIST_SUCCESS:
      return state.merge({
        auditList: {
          count: action.payload.data.data.count,
          values: action.payload.data.data.results,
        },
      })

    default:
      return state
  }
}
